// Dev-only error logger: avoids leaking internal errors to the console in production.
export function logError(...args) {
  if (process.env.NODE_ENV === "development") {
    // eslint-disable-next-line no-console
    console.error(...args);
  }
}
